module.exports = __webpack_public_path__ + "static/img/widget-8.2890dec7.png";